










































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import ListSaveWidget from '@/components/ListSaveWidget.vue';

import { ListModel } from '@/models/list-model';

import { UserModule } from '@/store/modules/user';

@Component({
  components: {
    ListSaveWidget
  }
})
export default class BigListCoverCard extends Vue {
  @Prop(Boolean) canEditList: boolean;
  @Prop(ListModel) list: ListModel;
  @Prop(Array) images: string[];
  @Prop(String) updatedDate: string;
  @Prop({ default: false }) debug: boolean;

  get isLoggedIn() {
    return UserModule.isLoggedIn;
  }
}
